import Alert, { type AlertColor } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export interface AdminSnackbarAlertProps {
  open: boolean;
  message: string | null;
  severity?: AlertColor;
  autoHideDuration?: number;
  onClose: () => void;
}

export const AdminSnackbarAlert = ({
  open,
  message,
  severity = 'error',
  autoHideDuration = 6000,
  onClose,
}: AdminSnackbarAlertProps) => (
  <Snackbar
    open={open && Boolean(message)}
    autoHideDuration={autoHideDuration}
    onClose={(_, reason) => {
      if (reason === 'clickaway') return;
      onClose();
    }}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  >
    <Alert severity={severity} variant="filled" onClose={onClose} sx={{ width: '100%' }}>
      {message}
    </Alert>
  </Snackbar>
);
